import apiClient from "../api/apiClient"
import { endPoints } from "../config/endpoints";

export const bannerService = {
    
     async getAllAsync(params) {
    const response = await apiClient.get(endPoints.banner.getAll, {
      params: params,
    });

    return response.data;
  },
  async getAllSearchAsync(params, signal) {
    const response = await apiClient.get(endPoints.banner.getAllSearch, {
      params: params,
      signal: signal,
    });

    return response.data;
  },
  async create(data) {
    const response = await apiClient.post(endPoints.banner.create, data);
    return response.data;
  },
  async update(id, data) {
    const response = await apiClient.post(
      `${endPoints.banner.update}/${id}`,
      data,
    );
    return response.data;
  },
  async edit(id) {
    const response = await apiClient.get(`${endPoints.banner.edit}/${id}`);
    return response.data;
  },
  async deleteImageAsync(id) {
    const response = await apiClient.delete(
      `${endPoints.banner.deleteImage}/${id}`,
    );
    return response.data;
  },
   async deleteAsync(id) {
    const response = await apiClient.delete(
      `${endPoints.banner.delete}/${id}`,
    );
    return response.data;
  },
  async getDetails(id) {
    const response = await apiClient.get(
      `${endPoints.banner.getDetails}/${id}`,
    );
    return response.data;
  }
}